import apiFetch from '../apiFetch'

export default function (token, roleId) {
  return apiFetch({ endPoint: `role/${roleId}`, method: 'POST', body: null, token: token })
}
